import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import DeconsolidationForm from "./DeconsolidationComponents/DeconsolidationForm"; // You'll need to create this
import { useAddDeconsolidationMutation } from "store/services/deconsolidationApi";

const DeconsolidationCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Deconsolidations", path: "/app/crm/deconsolidation/list" },
    { title: "New Deconsolidation" }
  ];

  const [createDeconsolidation, { isLoading: creatingDeconsolidation }] = useAddDeconsolidationMutation();

  const handleAddDeconsolidation = async (data) => {
    try {
      const { _id } = await createDeconsolidation(data).unwrap();
      toast.success("Deconsolidation Created!");
      navigate(`/app/crm/deconsolidation/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could not create Deconsolidation!"
      );
    }
  };

  useAppMeta("New Deconsolidation");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingDeconsolidation}>
      <BreadcrumbLayout.Paper>
        <DeconsolidationForm 
          isBusy={creatingDeconsolidation} 
          onSubmit={handleAddDeconsolidation} 
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DeconsolidationCreateScreen;